// @ts-check

export function num(v, fallback = 0) {
    const n = typeof v === 'string' ? parseFloat(v) : Number(v);
    return Number.isFinite(n) ? n : fallback;
  }
  
  export function pctToDecimal(v, fallback = 0) {
    // UI: "3" => 0.03, "0.03" => 0.03
    const n = num(v, fallback);
    if (!Number.isFinite(n)) return fallback;
    return n > 1 ? n / 100 : n;
  }
  
  export function requireFields(obj, fields) {
    const missing = fields.filter((k) => obj == null || obj[k] == null || obj[k] === '');
    return { ok: missing.length === 0, missing };
  }
  
  export function clampMin0(n) {
    return n < 0 ? 0 : n;
  }
  
  export function round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100;
  }
  